<template>
<el-dialog :visible.sync="dialogVisible" top="0" width="565px" :before-close="closeModal">
    <AlertDelete class="d-flex mt-5 mb-2 mx-auto"/>
    <h3 class="c-ndarkthree bold text-center mb-2">
        Deseja desativar esta empresa?
    </h3>
    <p class="c-ndarkfour regular text-center">
        Tem certeza de que deseja desativar esta empresa da plataforma?
    </p>
    <span slot="footer" class="dialog-footer d-flex justify-content-end align-items-center">
        <router-link to="" @click.native="closeModal"  :class="`${getPrimaryColor} mr-4 pointer`">
            <p class="c-ndarkfour">
                Cancelar
            </p>
        </router-link>
        <button :class="`btn btn-${getPrimaryColor}`" @click="deleteCompany">
            OK, desativar
        </button>
    </span>
</el-dialog>
</template>

<script>
import AlertDelete from '@/components/icons/AlertDelete'
export default {
    components: {
        AlertDelete
    },
    props: {
        dialogVisible: {
            required: true,
            type: Boolean,
            default: false
        },
    },
    data() {
        return {}
    },
    methods: {
        closeModal() {
            this.$emit('closeModal', false)
        },
        deleteCompany() {
            this.$emit('confirmDelete')
        }
    },
}
</script>

<style>
</style>